@use '@/styles/tokens' as *;

// The three From/To pairs and the date range are not <FormField>s, so each carries its own
// legend. Mirrors FormField's vertical rhythm and label look (form-field.module.scss) so the
// four line up with the three MultiSelectFields above them.
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: $font-size-md;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

// Figma 294:259878: two equal inputs, 16px apart. `min-width: 0` lets them actually shrink —
// each child is a <FormField> wrapper, not the input itself.
.row {
  display: flex;
  gap: var(--space-4);
}

.row > * {
  flex: 1 1 0;
  min-width: 0;
}
